import type { ProjectEnvironment } from '../../services/projectDataApi'
import StatusFilter from '../StatusFilter'

interface BugEnvironmentFilterProps {
  value: string
  onChange: (value: string) => void
  environments: ProjectEnvironment[]
}

export const PROJECT_DEFAULT_ENVIRONMENT = 'project-default'

export default function BugEnvironmentFilter({ value, onChange, environments }: BugEnvironmentFilterProps) {
  const options = [
    { value: 'all', label: 'All' },
    { value: PROJECT_DEFAULT_ENVIRONMENT, label: 'Project default' },
    ...environments.map(environment => ({ value: environment.id, label: environment.name })),
  ]

  return (
    <StatusFilter
      value={value}
      onChange={onChange}
      options={options}
      label="Environment"
      analyticsPrefix="bug-environment-filter"
      testId="environment-filter"
    />
  )
}
